import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'enrich-page-customer-not-found',
  templateUrl: './customer-not-found.page.html',
  styleUrls: ['./customer-not-found.page.sass'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomerNotFoundPage { }



// WEBPACK FOOTER //
// ./src/app/pages/errors/customer-not-found/customer-not-found.page.ts